import { useContext, useMemo } from 'react';
import { buildTracksFromWorksites } from '../../../../utils/worksites';
import { MapContext } from '../../contexts/map';
import { useStyleBuilders } from '../../effects';
import { useDrawTracksOnMap, useOverTracks, useTracksDefaultStyle } from '../Tracks/effects';
import { useDrawWorksitesOnMap } from './effects';

const Worksite = function ({ worksite, events, hideWorksiteTooltip }) {
  const { map } = useContext(MapContext);
  useDrawWorksitesOnMap(map, worksite, events, hideWorksiteTooltip);
  return null;
};

const Worksites = function ({
  worksites,
  events,
  hideActiveSession,
  hideWorksiteTooltip,
  trackEvents,
  overTrackID,
  overStyle,
  tracksWithoutFlags,
}) {
  const { map } = useContext(MapContext);
  const worksitesTracks = useMemo(
    () => (hideActiveSession ? null : buildTracksFromWorksites(worksites)),
    [worksites, hideActiveSession],
  );

  const defaultTrackStyle = useTracksDefaultStyle();
  const styles = useMemo(() => [defaultTrackStyle], [defaultTrackStyle]);
  const trackStyles = useStyleBuilders(styles);
  const [tracksMap, decoratorsMap] = useDrawTracksOnMap(
    map,
    worksitesTracks,
    trackEvents,
    trackStyles,
    undefined,
    tracksWithoutFlags,
    false,
  );
  useOverTracks({ overTrackID, tracksMap, decoratorsMap, trackStyles, overStyle });
  return (
    <>
      {(worksites || []).map((w) => (
        <Worksite
          key={`map-worksite-${w.device_session_id}-${w.cluster_id}`}
          worksite={w}
          events={events}
          hideWorksiteTooltip={hideWorksiteTooltip}
        />
      ))}
    </>
  );
};

export default Worksites;
